import * as React from 'react';
import classNames from 'classnames';

import * as styles from './TabWrapper.css';

export interface ITabWrapperProps {
  isActive: boolean;
  children: React.ReactNode;
  onClick(): void;
}

export const TabWrapper: React.FC<ITabWrapperProps> = ({ isActive, onClick, children }) => (
  <button
    className={classNames(styles['container'], isActive ? styles['active'] : styles['inactive'])}
    type="button"
    onClick={onClick}
  >
    {children}
  </button>
);
